import { useDispatch } from "react-redux";

import { AppThunkDispatch } from "../../types";

export const useTypedDispatch: () => AppThunkDispatch = useDispatch;
